/**
 * Pure formatting helpers for attribute keys.
 *
 * Kept out of `attributes.utils` so that data-layer modules can reach them without loading
 * `common/form/Validator`, which pulls in the React i18n graph.
 */
export const removeSpecialCharactersAndCamelizeKey = (text) => {
    const a = text.toLowerCase().replace(/[^a-zA-Z0-9]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''));
    return a.substring(0, 1).toLowerCase() + a.substring(1);
};
